export default __webpack_public_path__ + "static/media/img2.db07f1b6.avif";